// extracted by mini-css-extract-plugin
module.exports = {"container":"LevelComplete_container__2xagM","anim":"LevelComplete_anim__3SoB7","icon":"LevelComplete_icon__2mrGE"};